import React from "react";
import Collapsible from "react-collapsible";
import "../../styles/uploadimage.css";
import "../../styles/static-content.css";


export default class FAQS extends React.Component {

    constructor(props) {
        super(props);

    }

    render() {

        return (
            <div className="col-sm-12 background-grey">
                <article className="post-88 page type-page status-publish hentry">
                    <div className="woocommerce">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <div className="heading-welcome_">
                                    FREQUENTLY ASKED QUESTIONS
                                    <hr className="line-category-name margin-auto"></hr>
                                </div>
                            </div>

                            <div className="col-sm-6 UploadPaintingCard no-margin padding-35 ConfirmBuyRequest">


                                <div className="col-md-12">


                                    <h2 className="static-heading text-center">
                                        Registration
                                    </h2>
                                    <div className="ws-text-separator mb-25"></div>

                                    <Collapsible trigger="1. What is the registration process for YourMasterpieces?">
                                        <p className="static-text-inside">
                                        Registering with us is a simple and fast process. <a
                                            href="https://yourmasterpieces.com"
                                            className="link"> Click here </a>
                                            {/* or visit <a href="https://yourmasterpieces.com/auth/login.php"
                                                        className="link"> My
                                            Account </a>  */}
                                            and fill in your basic details, and click on ‘Register’. 
                                            Once you have successfully registered, please tell us about yourself in the ‘Bio’ section.
                                             You can update your country, city and contact number in the ‘Edit Profile’ section and start uploading your artwork by clicking on ‘Upload Art’ button. 
                                        

                                            {/* <a href="terms&amp;conditions.php" className="link"> Terms
                                                and Conditions</a> for more details. */}
                                        </p>
                                    </Collapsible>

                                    <Collapsible trigger="2. Is there any eligibility criteria for artist registration on
                                                                    YourMasterpieces?">
                                        <p className="static-text-inside">
                                        YourMasterpieces does not restrict users of any age, however users below the age of 18 are expected to have an adult handle their transactions. The users are expected to be 18 years and above to be able to sign a legally binding contract of sale. We also request minors to provide us with the email of their legal guardian. 

                                        </p>

                                    </Collapsible>

                                    <Collapsible trigger="3. Is there a registration fee?">
                                        <p className="static-text-inside">
                                        We are an open platform for artists, buyers and art lovers. You can register with us without any registration fee.

                                        </p>

                                    </Collapsible>

                                    <Collapsible trigger="4. Is there a separate registration process for an artist or a buyer ">
                                        <p className="static-text-inside">
                                        No. At YourMasterpieces, the registration process is common for artists, buyers or art lovers. You can declare your preference for using the platform while signing up. 

                                        </p>

                                    </Collapsible>



                                    <h2 className="static-heading text-center mt-25">
                                        Artworks
                                    </h2>
                                    <div className="ws-text-separator mb-25"></div>


                                    <Collapsible trigger="1. How do I report fraud and
                                                                    inappropriate content on the platform?">
                                        <p className="static-text-inside">

                                        If you would like to report a user or an artwork for fraud, inappropriate content or violation of the terms of use of YourMasterpieces you can click on the report button or contact us at
                                          {` ` }  <a href="mailto:contact@yourmasterpieces.com" className="link">contact@yourmasterpieces.com</a>
                                            with a valid explanation and evidence, if possible, of the violation. Once an artwork or artist is reported, it will be blocked from view, pending a review from our team.


                                        </p>

                                    </Collapsible>


                                    <Collapsible trigger="2. What qualifies as mature content on the platform?
                                                                ">
                                        <p className="static-text-inside">
                                        Any work that includes nudity, blood, guns, alcohol, drugs, violence, adult language and other similar content that may be considered not suitable for some audiences can be marked as mature content on our platform.

                                        </p>

                                    </Collapsible> 
                                    <Collapsible trigger="3. What qualifies as inappropriate content on the platform?">
                                        <p className="static-text-inside">
                                        Any artwork that has not been marked as mature content and happens to contain mature content can be flagged as inappropriate content by clicking on “Report this artwork” button. Our curators can then decide whether the work qualifies as inappropriate content. 

                                        </p>

                                    </Collapsible>

                                    <Collapsible trigger="4. How are the copyrights of my artwork managed?">
                                        <p className="static-text-inside">
                                        Artists' safety and privacy are our
                                         utmost priority at YourMasterpieces.
                                          Please visit our  <a className="link" href="/terms-and-conditions">Terms and Condition </a> page for more details on our copyright policies.

                                        </p>

                                    </Collapsible>

                                    <h2 className="static-heading text-center mt-25">
                                        Account
                                    </h2>
                                    <div className="ws-text-separator mb-25"></div>


                                    <Collapsible trigger="1. Can I add personal profile
                                                                    link to my bio?">
                                        <p className="static-text-inside">
                                        No, YourMasterpieces does not allow personal profile links to be posted in the bio section. If you happen to put up your work somewhere else and it has been sold, you must update the artwork to display “Not for sale” on your profile.  
                                        </p>

                                    </Collapsible>

                                    <Collapsible trigger="2. How do I add artworks to my collection?">
                                        <p className="static-text-inside">
                                        You can add artworks to your collection simply by clicking on the 'heart' icon next to the painting of your choice. You can view the collection on your profile page.

                                        </p>

                                    </Collapsible>

                                    <Collapsible trigger="3. How do I change my account details?">
                                        <p className="static-text-inside">
                                        You can update your account details by visiting your profile section and clicking ‘Edit Profile’ anytime. This includes your account password, email, shipping address, and billing information.

                                        </p>

                                    </Collapsible>

                                    <Collapsible trigger="4. I forgot my login password. How can I request a new one?
">
                                        <p className="static-text-inside">

                                        Click on Forgot Password on the login screen. Follow the on-screen instructions and we will send you an email with a link to reset your password. If you do not receive an email from YourMasterpieces within a few minutes, please check your spam or junk folder of your email account to see if our email was filtered there. If that doesn’t work, request a new password again and ensure that you are entering your email address correctly. 
                                        Make sure <a
                                            href="mailto:support@yourmasterpieces.com" className="link">
                                            support@yourmasterpieces.com </a> is added to your safe sender list to receive our emails in your inbox. If you've checked all the above and still do not receive your email, please contact us at
                                             <a href="mailto:support@yourmasterpieces.com"
                                                             className="link"> support@yourmasterpieces.com </a>


                                        </p>

                                    </Collapsible>

                                    <Collapsible trigger="5. Can I switch my profile
                                                                    from a Buyer to an Artist or vice versa?">
                                        <p className="static-text-inside">
                                        At YourMasterpieces, the registration process is common for artists, buyers or art lovers. You are free to browse, upload and buy artworks via the same profile. 
                                        </p>

                                    </Collapsible>

                                    <h2 className="static-heading text-center">
                                        Buying
                                    </h2>
                                    <div className="ws-text-separator mb-25"></div>

                                    <Collapsible trigger="1. As a buyer, do I have to pay for the shipping and handling cost?
">
                                        <p className="static-text-inside">
                                        Yes, depending on where the order is being shipped, sales tax will be charged on the order subtotal, shipping, and/or handling charges at the applicable county rate.  We will provide you with a clear breakdown of the charges.

                                        </p>

                                    </Collapsible>

                                    <Collapsible trigger="2. How do I check the status of my order?

">
                                        <p className="static-text-inside">
                                        Once you have successfully placed an order on YourMasterpieces, we will keep you notified on the status of the order by email and share the tracking link as soon as the order is dispatched.

                                        </p>

                                    </Collapsible>
                                    <Collapsible trigger="3. What is your Return and Exchange policy?

">
                                        <p className="static-text-inside">
                                        All items on our site are for final sale and are not eligible for a return or exchange. However, if the artwork received is damaged and you notify us about it within 48 hours of delivery, it will be considered for return or exchange. After our team has reviewed it, we will replace the art if a copy of it is available or issue a full refund, excluding shipping charges. 
Make sure to note the damage or quality issues along with a photograph of the damaged artwork. Please include a detailed description of your dissatisfaction including locations of the issues on the artwork, your order number, and the name of the artwork that was damaged. Send this information to us at support@yourmasterpiece.com or reply to the post-delivery satisfaction email that you receive after the artwork is delivered.
If the artwork is different from what you ordered, we apologize for the inconvenience. Please write to us within 48 hours of delivery at {` `}<a
                                            href="mailto:support@yourmasterpieces.com" className="link">support@yourmasterpieces.com </a>. Our Support team will get back to you with the process to procure the artwork you originally wanted to buy.


                                        </p>

                                    </Collapsible>
                                    <Collapsible trigger="4. What Payment methods do you accept?">
                                        <p className="static-text-inside">
                                        YourMasterpieces platform accepts payments via Visa, MasterCard and Paypal. 

                                        </p>

                                    </Collapsible>
                                    <Collapsible trigger="5. How do I make a payment for purchase?">
                                        <p className="static-text-inside">
                                        When you place an order, we will send you a link by email to make the payment. We then authorize your card to confirm if it is valid and to ensure that there are sufficient funds available for your purchase. The shipment is not initiated if the transaction fails. 


                                        </p>

                                    </Collapsible>
                                    <Collapsible trigger="6. How do I cancel my order?
">
                                        <p className="static-text-inside">
                                        An order may be canceled if the cancel request is made within 24 hours of your purchase by contacting us at  {` `}
                                        <a
                                            href="mailto:support@yourmasterpieces.com" className="link">support@yourmasterpieces.com </a>.



                                        </p>

                                    </Collapsible>
                                    <Collapsible trigger="8. Do you provide help in installing the art?
">
                                        <p className="static-text-inside">
                                        Unfortunately, we do not provide the service to install artworks. The artwork will be couriered to the buyer without a frame unless a frame is a part of the artwork and is specified by the artist. 

                                      



                                        </p>

                                    </Collapsible>
                                    <Collapsible trigger="9. How do I know if the art purchased is original?
">
                                        <p className="static-text-inside">
                                        YourMasterpieces procures artworks directly from artists and art communities, however, pre-owned artworks can be uploaded by community members. Users are required to declare whether they have created an artwork while uploading it. Any artwork marked as “created by me” is an original artwork made by the user. 

                                      



                                        </p>

                                    </Collapsible>
                                    
                                    <h2 className="static-heading text-center mt-25">
                                        Selling
                                    </h2>
                                    <div className="ws-text-separator mb-25"></div>

                                    <Collapsible trigger="1. Do you charge any commissions to the artists on the paintings?


">
                                        <p className="static-text-inside">
                                        We at YourMasterpieces believe the artist deserves the full price for their hard work and hence no commission, taxes, shipping and handling costs are charged to the artists.


                                      



                                        </p>

                                    </Collapsible>
                                    <Collapsible trigger="2. As an Artist, do I have to pay for the shipping and handling cost?
">
                                        <p className="static-text-inside">
                                        We support the artists and value their efforts in creating art. Hence, we will not charge the artists for any shipping and/or handling costs.




                                        </p>

                                    </Collapsible>
                                    <Collapsible trigger="3. Can I sell a pre-owned artwork?
">
                                        <p className="static-text-inside">
                                        You can resell pre-owned art. However, while uploading the artwork, ensure that you uncheck the “Created by me” option. Please read our 
                                       <a className="link" href="/terms-and-conditions"> Terms and Conditions </a>
                                        page for more clarity.




                                        </p>

                                    </Collapsible>
                                    <Collapsible trigger="4. I have shipped my artwork. When will I receive the payment?

">
                                        <p className="static-text-inside">
                                        Payment for your artwork will be transferred to your account once the artwork has been delivered to the buyer. Buyers have a 48 hour period to report issues with the delivery. Once this period passes, YourMasterpieces will transfer the amount to your bank account. In the interim, once your have shipped the artwork, YourMasterpieces will provide you with credits in value equalling the price of the artwork. 



                                        </p>

                                    </Collapsible>
                                    <h2 className="static-heading text-center mt-25">
                                    Custom art requests
                                    </h2>
                                    <div className="ws-text-separator mb-25"></div>

                                    <Collapsible trigger="1. What are custom art requests?">
                                        <p className="static-text-inside">
                                        Custom art requests can include special requests for murals, modification of an existing artwork from a specific artist (directed solely towards that artist), artworks to suit a certain theme, or artworks to fit in a certain space.



                                        </p>

                                    </Collapsible>
                                    <Collapsible trigger="2. Who can submit custom art requests?
">
                                        <p className="static-text-inside">
                                        Anyone can submit custom art requests! 
                                        </p>

                                    </Collapsible>
                                    <Collapsible trigger="3. Who can accept the custom art requests?">
                                        <p className="static-text-inside">
                                        If you are an artist willing to make a certain customised artwork, you can respond to the requests by replying to the customized artwork request email with a price quote and the time it will take for you to deliver on that artwork. The buyers will then select the artist from the offers they receive. 

                                        </p>

                                    </Collapsible>
                                    <Collapsible trigger="4. How will YourMasterpieces assist with custom art requests?
">
                                        <p className="static-text-inside">
                                        In order to ensure security in customized artwork transactions, YourMasterpieces will sign separate contracts with the artist and the buyer respectively. The artist has to deliver the artwork in the quoted time period. The buyer has to transfer the funds for the custom art request once the contract is signed. YourMasterpieces will transfer the funds to the artist on delivery of the artwork in accordance with our shipment policy for non-customized artworks. 




                                        </p>

                                    </Collapsible>
                                </div>


                            </div>
                        </div>

                    </div>
                </article>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/static/faqs.js